import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';
import type { BookingPaymentDetails } from '../../types/api/v1/obt/pnr/payment';

export function getPaymentSourceIdsForPaymentDetails(paymentDetails: BookingPaymentDetails): string[] {
  const { selectedFops } = paymentDetails.bookingTravelerPaymentDetails[0];
  const selectedPayments = selectedFops.flatMap((fop) => fop.selectedPayments);

  const paymentSourceIds = selectedPayments.map((payment) => payment.paymentSourceId);
  return sortBy(uniq(paymentSourceIds));
}
